import { toast } from 'react-toastify';
import type { Middleware, MiddlewareAPI } from '@reduxjs/toolkit';
import { isRejectedWithValue } from '@reduxjs/toolkit';

const AI_HANDLERS = ['generateSummaryAI', 'generateWorkHisotryAI'];

/**
 * Log a warning and show a toast!
 */
export const rtkQueryErrorLogger: Middleware = (api: MiddlewareAPI) => (next) => (action) => {
  if (AI_HANDLERS.includes(action?.meta?.arg?.endpointName) && isRejectedWithValue(action)) {
    toast.error('Apologies, please try again later.');
  }

  return next(action);
};
